import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';

function Stats() {
  const stats = [

    { value: '99%', label: 'Secure Transactions' }
  ];

  return (
    <Box sx={{ 
      py: { xs: 6, md: 8 }, 
      backgroundColor: '#050505',
      borderTop: '1px solid rgba(212, 175, 55, 0.1)',
      borderBottom: '1px solid rgba(212, 175, 55, 0.1)'
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {stats.map((item, index) => (
            <Grid item xs={12} sm={6} md={6} key={index} sx={{ 
              textAlign: 'center',
              position: 'relative',
              '&:not(:last-child)': {
                borderRight: { md: '1px solid rgba(212, 175, 55, 0.15)' },
              }
            }}>
              <Typography variant="h2" sx={{
                fontFamily: "'Playfair Display', serif",
                color: '#ffffff',
                fontSize: { xs: '3.5rem', md: '4.5rem' },
                lineHeight: 1,
                mb: 0.5,
                textShadow: '0 0 30px rgba(212, 175, 55, 0.2)',
              }}>
                {item.value}
              </Typography>
              <Typography variant="subtitle1" sx={{
                color: '#c0c0c0',
                textTransform: 'uppercase',
                letterSpacing: '3px',
                fontSize: '0.85rem',
                fontWeight: 500,
              }}>
                {item.label}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Stats;